import { render, staticRenderFns } from "./payments_form.vue?vue&type=template&id=0130421c&"
import script from "./payments_form.vue?vue&type=script&lang=js&"
export * from "./payments_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports